var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3410_9308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2305 25.0004H11.2424C10.3828 24.9994 9.55859 24.6575 8.95073 24.0496C8.34286 23.4417 8.00095 22.6175 8 21.7579V11.7699C8.00095 10.9102 8.34286 10.086 8.95073 9.47815C9.55859 8.87026 10.3828 8.52832 11.2424 8.52734H21.2305C22.0902 8.52832 22.9144 8.87026 23.5222 9.47815C24.1301 10.086 24.472 10.9102 24.473 11.7699V21.7579C24.472 22.6175 24.1301 23.4417 23.5222 24.0496C22.9144 24.6575 22.0902 24.9994 21.2305 25.0004ZM11.2424 9.67467C10.6869 9.67531 10.1544 9.89626 9.76163 10.2891C9.36886 10.6819 9.14794 11.2144 9.14732 11.7699V21.7579C9.14794 22.3134 9.36886 22.8459 9.76163 23.2387C10.1544 23.6315 10.6869 23.8525 11.2424 23.8531H21.2305C21.786 23.8525 22.3186 23.6315 22.7113 23.2387C23.1041 22.8459 23.325 22.3134 23.3256 21.7579V11.7699C23.325 11.2144 23.1041 10.6819 22.7113 10.2891C22.3186 9.89626 21.786 9.67531 21.2305 9.67467H11.2424Z",
    fill: "url(#paint0_linear_3410_9308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9038 12.8281H8.57812V13.9755H23.9038V12.8281Z",
    fill: "url(#paint1_linear_3410_9308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.144 11.7058C21.0686 11.7058 20.994 11.691 20.9244 11.6622C20.8548 11.6333 20.7916 11.5911 20.7383 11.5378C20.6851 11.4845 20.6428 11.4213 20.614 11.3517C20.5851 11.2821 20.5703 11.2075 20.5703 11.1322V7.57366C20.5703 7.42152 20.6308 7.2756 20.7383 7.16802C20.8459 7.06044 20.9918 7 21.144 7C21.2961 7 21.442 7.06044 21.5496 7.16802C21.6572 7.2756 21.7176 7.42152 21.7176 7.57366V11.1322C21.7177 11.2075 21.7028 11.2821 21.674 11.3517C21.6452 11.4213 21.6029 11.4845 21.5496 11.5378C21.4964 11.5911 21.4331 11.6333 21.3635 11.6622C21.2939 11.691 21.2193 11.7058 21.144 11.7058Z",
    fill: "url(#paint2_linear_3410_9308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3237 11.7058C11.2483 11.7058 11.1737 11.691 11.1041 11.6622C11.0345 11.6333 10.9713 11.5911 10.918 11.5378C10.8647 11.4845 10.8225 11.4213 10.7937 11.3517C10.7648 11.2821 10.75 11.2075 10.75 11.1322V7.57366C10.75 7.42152 10.8104 7.2756 10.918 7.16802C11.0256 7.06044 11.1715 7 11.3237 7C11.4758 7 11.6217 7.06044 11.7293 7.16802C11.8369 7.2756 11.8973 7.42152 11.8973 7.57366V11.1322C11.8973 11.2075 11.8825 11.2821 11.8537 11.3517C11.8248 11.4213 11.7826 11.4845 11.7293 11.5378C11.6761 11.5911 11.6128 11.6333 11.5432 11.6622C11.4736 11.691 11.399 11.7058 11.3237 11.7058Z",
    fill: "url(#paint3_linear_3410_9308)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9308",
    x1: 23.1368,
    y1: 8.52734,
    x2: 13.3443,
    y2: 18.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3410_9308",
    x1: 22.6607,
    y1: 12.8281,
    x2: 22.5638,
    y2: 14.1869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3410_9308",
    x1: 21.6246,
    y1: 7,
    x2: 20.2794,
    y2: 7.34419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3410_9308",
    x1: 11.8043,
    y1: 7,
    x2: 10.4591,
    y2: 7.34419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3410_9308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f13f7bc6.svg";
export { ForwardRef as ReactComponent };